<script setup>
  import { ref, watch } from 'vue';
  import BaseModal from '@/components/base/BaseModal.vue';

  const showModal = defineModel();

  const props = defineProps({
    downloadInfo: {
      type: Object,
      required: true
    }
  });

  const blobUrl = ref(null);

  watch(showModal, async (open) => {
    if (!open) {
      if (blobUrl.value) {
        URL.revokeObjectURL(blobUrl.value);
        blobUrl.value = null;
      }
      return;
    }
    const response = await fetch(props.downloadInfo.url);
    const blob = await response.blob();
    blobUrl.value = URL.createObjectURL(blob);
  });

  function handleDownloadData() {
    // Defer closing the modal so the browser can start reading the blob
    // before the watcher revokes its object URL. Revoking synchronously here
    // kills the download mid-flight and Chrome reports it as a network error.
    setTimeout(() => {
      showModal.value = false;
    }, 0);
  }
</script>

<template>

  <BaseModal
    v-model="showModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">Archive Data Download</h2>
    </header>          
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <div class="jwx-page-block jwx-meta-data__list-block-body">
          <ul class="jwx-meta-data__list">
            <li class="jwx-meta-data__list-item">
              <span class="jwx-meta-data__list-item-title">Start Date:</span>
              <div class="jwx-meta-data_list-item-body">
                <span class="jwx-meta-data__list-item-value">{{ props.downloadInfo.startDate }}</span>
              </div>
            </li>
            <li class="jwx-meta-data__list-item">
              <span class="jwx-meta-data__list-item-title">End Date:</span>
              <div class="jwx-meta-data_list-item-body">
                <span class="jwx-meta-data__list-item-value">{{ props.downloadInfo.endDate }}</span>
              </div>
            </li>
            <li class="jwx-meta-data__list-item">
              <span class="jwx-meta-data__list-item-title">File Type:</span>
              <div class="jwx-meta-data_list-item-body">
                <span class="jwx-meta-data__list-item-value">{{ props.downloadInfo.type.toUpperCase() }}</span>
              </div>
            </li>
            <li class="jwx-meta-data__list-item" data-direction="column">
              <span class="jwx-meta-data__list-item-title">Fields:</span>
              <div class="jwx-meta-data__list-item-body" data-full-width>
                <span class="jwx-meta-data__list-item-value">
                  All available fields. Can include the following: station meta data. wind(avg.gust.lull.dir), air temperature, pressure. precipitation, water temperature, wave height, wave period.
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button 
          type="button" 
          @click.prevent="showModal = false;"
          class="jwx-button"
        >
          Cancel
        </button>
        <a
          :href="blobUrl"
          :download="props.downloadInfo.filename || 'archive.csv'"
          @click="handleDownloadData"
          class="jwx-button jwx-button--success"
          :class="{ 'jwx-button--disabled': !blobUrl }"
        >
          Download
        </a>
      </div>
    </div>                  
  </BaseModal>  
</template>